export default __webpack_public_path__ + "static/media/SM1.044e649d.jpg";